import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateTimePipe } from '@nimmsta/ng-commons-lib/pipes';
import {
  Software,
  SoftwareArtifact,
  SoftwareArtifactStatus,
} from '@nimmsta/ng-commons-lib/models';
import { RouterLink } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { SoftwareArtifactDownloadButtonComponent } from './software-artifact-download-button.component';
import { MarkdownComponent } from 'ngx-markdown';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-software-item',
  templateUrl: './software-item.component.html',
  styleUrls: ['./software-item.component.scss', './software-label.scss'],
  imports: [
    RouterLink,
    NgOptimizedImage,
    SoftwareArtifactDownloadButtonComponent,
    MarkdownComponent,
    TranslatePipe,
    DateTimePipe,
  ],
})
export class SoftwareItemComponent implements OnInit {
  @Input() software!: Software;

  @Input() isAdmin = false;

  @Output() edit = new EventEmitter<void>();

  SoftwareArtifactStatus = SoftwareArtifactStatus;

  latestArtifact?: SoftwareArtifact;

  showDetails = false;

  ngOnInit(): void {
    this.latestArtifact = this.software.artifacts?.[0];
    if (this.latestArtifact) {
      const releaseDateToShow =
        !!this.latestArtifact.releaseDate &&
        this.latestArtifact.status === SoftwareArtifactStatus.RELEASED;
      const adminDetailsToShow =
        this.isAdmin &&
        !!(this.latestArtifact.branchName || this.latestArtifact.creationDate);
      this.showDetails =
        !!this.latestArtifact.buildNumber ||
        releaseDateToShow ||
        adminDetailsToShow;
    }
  }
}
